import {
    Modal, ModalOverlay, ModalContent, Avatar, ModalBody, Button, ModalCloseButton,
} from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'
import LoginComp from "../../Static_pages/LoginPage/LoginComp";
import { useLocation ,Link} from 'react-router-dom';
import users from "../../Logo/users.svg"

export const LoginPopUp = () => {
    const Location = useLocation();
    const { isOpen, onClose } = useDisclosure()

    const productPage = () => {
        return Location.pathname.includes('product');
    }
    
       const renderLoginButton = () => {
          if (productPage()) {
            return <>  
                <Button className="icons_with_text_button" fontWeight="normal">
                    <Link to='/login'>         
                        <Avatar className='header_icons_mt_new_Drillcut icon' bg='white'
                            src={users} alt="User icon">
                        </Avatar>
                        <span className='icons_with_text_button_text'>Account Login</span>
                    </Link>
                </Button>
                <Modal id="product_sign_in_popup" size="xl" isOpen={isOpen} onClose={onClose}>
                     <ModalOverlay />
                     <ModalContent>
                         <ModalCloseButton />
                         <ModalBody>
                             <LoginComp />
                         </ModalBody>
                     </ModalContent>
                </Modal>
            </>;
          } else {
            return <Button className="icons_with_text_button" aria-label="Account Login">
            <Link to='/login'>
                <Avatar className='header_icons_mt_new_Drillcut icon' bg='white'
                        src={users} alt="User icon">
                </Avatar>
                <span className='icons_with_text_button_text'>Account Login</span>
            </Link>
        </Button>;
          }
        }
    
    return (<>{
        renderLoginButton()
    }</> )
}